"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Svg = _styledComponents.default.svg.withConfig({
  componentId: "sc-60lvm5-0"
})(["margin:auto;"]);

var Check = function Check() {
  return /*#__PURE__*/_react.default.createElement(Svg, {
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "#FFF"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7133 0.48421L3.80744 7.39012L1.28665 4.84307C1.15536 4.73804 0.945295 4.73804 0.840263 4.84307L0.0787746 5.60456C-0.0262582 5.70959 -0.0262582 5.91966 0.0787746 6.05095L3.59737 9.54329C3.72867 9.67458 3.91247 9.67458 4.04376 9.54329L11.9212 1.66583C12.0263 1.5608 12.0263 1.35073 11.9212 1.21944L11.1597 0.48421C11.0547 0.352919 10.8446 0.352919 10.7133 0.48421Z",
    fill: "white",
    strokeWidth: "0.4"
  }));
};

var Minus = function Minus() {
  return /*#__PURE__*/_react.default.createElement(Svg, {
    width: "12",
    height: "2",
    viewBox: "0 0 12 2",
    fill: "#FFF"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 1H6H12",
    stroke: "wh ite",
    strokeWidth: "2"
  }));
};

var Icons = {
  check: Check,
  minus: Minus
};
var _default = Icons;
exports.default = _default;